import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  TaskListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/task-list.response';
import { CheckRowComponent } from '../../ui-components/check-row/check-row.component';
import { LabelPipe } from '../../pipes/LabelPipe';
import { VwDatePipe } from '../../pipes/vw-date.pipe';
import { TASK_EMOJIS } from '../../constants/garden-task.constants';
import { taskSection } from '../../utils/garden-todo.util';

/**
 * Une ligne de « Mes tâches » (maquettes 02 et 05), sur la ligne à cocher
 * commune : le rond coche, le reste de la ligne ouvre la feuille.
 * Pictogramme de la catégorie du geste, titre barré une fois coché, pastille
 * de la culture (« Potager » pour un geste général, porté par le contenu), et
 * l'échéance « jusqu'au » ; passé la fin de la fenêtre (la marge), la tâche
 * reste là sans date : ni retard ni compte à rebours.
 */
@Component({
  selector: 'vw-task',
  imports: [TranslatePipe, LabelPipe, VwDatePipe, CheckRowComponent],
  templateUrl: './task.component.html',
  // Bloc : sans cela l'hôte est en ligne et le `divide-y` du parent ne trace aucun filet entre les lignes.
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TaskComponent {
  @Input() task: TaskListResponse;
  @Input() checked = false;
  @Input() today = new Date();
  @Output() check = new EventEmitter<void>();
  @Output() open = new EventEmitter<void>();

  readonly emojis = TASK_EMOJIS;

  /** Fenêtre finie, tâche encore ouverte pendant sa marge : une date passée se lirait comme un reproche. */
  get pastWindow(): boolean {
    return taskSection(this.task, this.today) === 'closing';
  }
}
